import { memo } from 'react';

import { colors } from '@ui';

export const SceneLights = memo(() => {
    return (
        <>
            <ambientLight intensity={1.2} />
            <pointLight position={[-2, 2, 0]} color={colors.bluegray[100]} intensity={10} />
            <pointLight position={[1.25, 1, 1.5]} color={colors.bluegray[100]} intensity={15} />
            <pointLight position={[0, 1, -1.5]} color={colors.bluegray[100]} intensity={3} />
        </>
    );
});
